import React, { useState } from 'react'
import { Copy, Check } from 'lucide-react'
import { useTheme } from '@/context/ThemeContext'

type Props = { label: string; value: string }

const CopyField: React.FC<Props> = ({ label, value }) => {
  const { currentTheme: t } = useTheme()
  const [copied, setCopied] = useState(false)

  const copy = () => {
    navigator.clipboard.writeText(value).then(() => {
      setCopied(true)
      setTimeout(() => setCopied(false), 2000)
    })
  }

  return (
    <div className="flex flex-col gap-1.5">
      <label className="text-[11px] font-semibold uppercase tracking-[0.06em]" style={{ color: t.mutedText }}>
        {label}
      </label>
      <div className="flex items-center gap-2">
        <input
          readOnly
          value={value}
          className="flex-1 h-[42px] rounded-[10px] px-3.5 text-[12.5px] outline-none font-mono"
          style={{ backgroundColor: t.hoverBackground, border: `1px solid ${t.border}`, color: t.text }}
        />
        <button
          onClick={copy}
          className="w-[42px] h-[42px] rounded-[10px] flex items-center justify-center transition-colors shrink-0"
          style={{
            backgroundColor: copied ? t.successBackground : t.hoverBackground,
            border: `1px solid ${copied ? t.accent : t.border}`,
            color: copied ? t.successText : t.mutedText,
          }}
        >
          {copied ? <Check size={15} /> : <Copy size={15} />}
        </button>
      </div>
    </div>
  )
}

export default React.memo(CopyField)
